import { useEffect, useRef, useState } from 'react';
let instanceCount = 0;
export function usePortalNode(portalName = 'popover', portalClassName = '') {
    const uniquePortalName = useRef(`${portalName}-portal-${instanceCount++}`);
    const [portalContainer, setPortalContainer] = useState(null);
    useEffect(()=>{
        let root = document.getElementById(uniquePortalName.current);
        if (!root) {
            root = document.createElement('div');
            root.id = uniquePortalName.current;
            root.className = portalClassName;
            document.body.appendChild(root);
        }
        setPortalContainer(root);
        return ()=>{
            if (root) {
                setPortalContainer(null);
                root.remove();
            }
        };
    }, [
        portalClassName
    ]);
    return portalContainer;
}
